export const checkPricingExists = (pricingDetail = {}) => !!(pricingDetail?.incentive || pricingDetail?.salePrice || pricingDetail?.msrp);

export default { checkPricingExists };
